<template>
  <div class="home">
    <!-- 头部 -->
    <div class="header">
      <div class="left">
        <img src="../assets/logo3.png" />
        <div>四川卓远企业征信咨询有限公司</div>
      </div>
      <div class="right">
        <el-dropdown @command="handleCommand">
          <div class="info">
            <img size="small" src="../assets/user11.png" />
            <div class="name">{{ formInline.enterpriseName }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="myWarranty">我的</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 选择银行 -->
    <div class="box-title">
      <div class="wire"></div>
      <div class="title">银行保函</div>
    </div>
    <el-card class="insurance">
      <div
        class="insurance-item"
        @click="handleTabs(item, index)"
        :class="{ active: activeIndex == index }"
        v-for="(item, index) in newsList"
        :key="item.id"
      >
        <div class="item-left">
          <img :src="item.companyImg" />
          <div>{{ item.companyName }}</div>
        </div>
        <div class="item-right">
          <div @click="handleInsure(item.insuranceInstructions)">投保须知</div>
          <div @click="handleInsurance(item.insuranceClauses)">保险条款</div>
        </div>
      </div>
    </el-card>
    <!-- 完善投标信息 -->
    <div class="box-title">
      <div class="wire"></div>
      <div class="title">完善投标信息</div>
    </div>
    <el-card class="bid">
      <div class="bid-title">
        <!-- <img src="../assets/logo3.png" /> -->
        <div>投标项目信息</div>
      </div>
      <el-form
        :inline="true"
        :model="row"
        :rules="rules"
        ref="row"
        class="demo-form-inline"
      >
        <el-form-item label="项目名称" prop="projectName" label-width="110px">
          <el-input
            disabled
            v-model="row.projectName"
            placeholder="项目名称"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目编号" prop="projectAmount">
          <el-input
            disabled
            v-model="row.projectAmount"
            placeholder="项目编号"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item label="标段名称" prop="user" label-width="110px">
          <el-input
            disabled
            v-model="row.lotName"
            placeholder="标段名称"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item label="标段编号" prop="user" label-width="110px">
          <el-input
            disabled
            v-model="row.lotNo"
            placeholder="标段编号"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item label="保证金金额(元)" prop="user" label-width="110px">
          <el-input
            disabled
            v-model="row.bondAmount"
            placeholder="保证金金额(元)"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目金额(元)" prop="user" label-width="110px">
          <el-input
            disabled
            v-model="row.projectAmount"
            placeholder="项目金额(元)"
            style="width: 350px"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 企业信息 -->
    <el-card class="recognizee">
      <div class="recognizee-title">
        <!-- <img src="../assets/logo3.png" /> -->
        <div>企业信息</div>
      </div>
      <el-form
        :inline="true"
        :model="formInline"
        :rules="rules1"
        ref="formInline"
        class="demo-form-inline"
      >
        <el-form-item
          label="企业名称"
          prop="enterpriseName"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseName"
            placeholder="企业名称"
            style="width: 350px"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          label="企业信用代码"
          prop="enterpriseCreditCode"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseCreditCode"
            placeholder="企业信用代码"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="企业法人"
          prop="juridicalPerson"
          label-width="110px"
        >
          <el-input
            v-model="formInline.juridicalPerson"
            placeholder="企业法人"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item label="所属行业" prop="categoryStr" label-width="110px">
          <el-input
            v-model="formInline.categoryStr"
            placeholder="所属行业"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="企业经办人"
          prop="enterpriseOperator"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseOperator"
            placeholder="企业经办人"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="联系电话"
          prop="enterpriseOperatorPhone"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseOperatorPhone"
            placeholder="联系电话"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="企业性质"
          prop="enterpriseNature"
          label-width="110px"
        >
          <el-select
            v-model="formInline.enterpriseNature"
            placeholder="请选择企业性质"
            clearable
            style="width: 350px"
          >
            <el-option
              v-for="dict in enterpriseList"
              :key="dict.dictValue"
              :label="dict.dictLabel"
              :value="dict.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="企业注册地"
          prop="enterpriseRegistrationPlace"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseRegistrationPlace"
            placeholder="企业注册地"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="详细地址"
          prop="enterpriseAddress"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseAddress"
            placeholder="详细地址"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="企业基本账户"
          prop="enterpriseAccountNo"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseAccountNo"
            placeholder="企业基本账户"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="开户银行"
          prop="enterpriseCardNo"
          label-width="110px"
        >
          <el-input
            v-model="formInline.enterpriseCardNo"
            placeholder="开户银行"
            style="width: 350px"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 上传资料 -->
    <el-card class="recognizee">
      <div class="recognizee-title">
        <!-- <img src="../assets/logo3.png" /> -->
        <div>上传资料</div>
      </div>
      <el-descriptions>
        <el-descriptions-item
          label="营业执照"
          :span="3"
          :labelStyle="labelStyle"
        >
          <el-upload
            class="upload-demo"
            action="http://129.211.214.215:9092/common/upload"
            :on-change="handleChange1"
            :file-list="fileList1"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-descriptions-item>
        <el-descriptions-item
          label="财务报表"
          :span="3"
          :labelStyle="labelStyle"
        >
          <el-upload
            class="upload-demo"
            action="http://129.211.214.215:9092/common/upload"
            :on-change="handleChange2"
            :file-list="fileList2"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload></el-descriptions-item
        >
        <el-descriptions-item
          label="工程合同"
          :span="3"
          :labelStyle="labelStyle"
        >
          <el-upload
            class="upload-demo"
            action="http://129.211.214.215:9092/common/upload"
            :file-list="fileList3"
            :on-change="handleChange3"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload></el-descriptions-item
        >
        <el-descriptions-item
          label="中标通知书"
          :span="3"
          :labelStyle="labelStyle"
        >
          <el-upload
            class="upload-demo"
            action="http://129.211.214.215:9092/common/upload"
            :on-change="handleChange4"
            :file-list="fileList4"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload></el-descriptions-item
        >
      </el-descriptions>
    </el-card>

    <el-dialog l-dialog title="缴费" :visible.sync="isVisible" width="400px">
      <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        "
      >
        <img
          src="../assets/jiaofei.png"
          style="width: 200px; height: 200px; margin-bottom: 10px"
        />
        <div class="info">请扫码缴纳保单保函费用</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleRole" size="mini"
          >确定</el-button
        >
        <el-button @click="isVisible = false" size="mini">取消</el-button>
      </div>
    </el-dialog>

    <!-- 确认勾选 -->
    <div class="affirm">
      <el-checkbox v-model="checked"></el-checkbox>
      <div>本人已逐页阅读并同意《投保须知》,《投保人申明》</div>
    </div>
    <div class="btn">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">提交申请</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      labelStyle: {
        fontWeight: "bold",
        width: "100px",
        height: "40px",
        color: "#000",
        fontSize: "14px",
        marginLeft: "40px",
      },
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      isVisible: false,
      activeIndex: 0,
      checked: false,
      formInline: {
        enterpriseName: window.sessionStorage.getItem("enterpriseName"),
        enterpriseCreditCode: window.sessionStorage.getItem(
          "enterpriseCreditCode"
        ),
        juridicalPerson: window.sessionStorage.getItem("juridicalPerson"),
        categoryStr: window.sessionStorage.getItem("categoryStr"),
        enterpriseOperator: window.sessionStorage.getItem("enterpriseOperator"),
        enterpriseOperatorPhone: window.sessionStorage.getItem(
          "enterpriseOperatorPhone"
        ),
        enterpriseNature: window.sessionStorage.getItem("enterpriseNature"),
        enterpriseRegistrationPlace: window.sessionStorage.getItem(
          "enterpriseRegistrationPlace"
        ),
        enterpriseAddress: window.sessionStorage.getItem("enterpriseAddress"),
        enterpriseAccountNo: window.sessionStorage.getItem(
          "enterpriseAccountNo"
        ),
        enterpriseCardNo: window.sessionStorage.getItem("enterpriseCardNo"),
      },
      rules: {},
      rules1: {
        enterpriseOperator: [
          { required: true, message: "请输入企业经办人", trigger: "blur" },
        ],
        enterpriseOperatorPhone: [
          { required: true, message: "请输入企业经办人电话", trigger: "blur" },
        ],
        enterpriseNature: [
          { required: true, message: "请选择企业性质", trigger: "blur" },
        ],
        enterpriseRegistrationPlace: [
          { required: true, message: "请输入企业注册地", trigger: "blur" },
        ],
        enterpriseAccountNo: [
          { required: true, message: "请输入企业基本账户", trigger: "blur" },
        ],
        enterpriseCardNo: [
          { required: true, message: "企业基本账户开户银行", trigger: "blur" },
        ],
      },
      newsList: [],
      enterpriseList: [],
      row: {},
      bankId: "",
      restaurants: [],
    };
  },
  mounted() {
    this.getNewsList();
    this.getEnterpriseList();
    this.row = JSON.parse(window.sessionStorage.getItem("row"));
  },
  methods: {
    // input搜索请求接口 querySearch参数名 cb回调函数
    async querySearchAsync(querySearch, cb) {
      if (querySearch && querySearch.length > 0) {
        try {
          const { data: res } = await this.$http.post(
            `http://129.211.214.215:8080/qycx/qycx?qymc=${encodeURIComponent(
              querySearch
            )}`
          );

          this.restaurants = res.data;

          if (this.restaurants.length == 0) {
            this.restaurants.push({
              id: "-1",
              value: "无匹配结果",
            });
            cb(this.restaurants);
          } else {
            let list = this.restaurants.map((item) => {
              return {
                value: `${item.name}`,
                creditcode: `${item.creditcode}`,
                reglocation: `${item.reglocation}`,
                enterpriseRegistrationPlace: `${item.base}${item.city}${item.district}`,
              };
            });
            cb(list);
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    // 监听输入框搜索的数据
    handleSelect(item) {
      this.formInline.enterpriseCreditCode = item.creditcode;
      this.formInline.enterpriseAddress = item.reglocation;
      this.formInline.enterpriseRegistrationPlace =
        item.enterpriseRegistrationPlace;
    },
    setBlur() {
      //  在点击由 clearable 属性生成的清空按钮时，主动触发失去焦点，解决‘fetch-suggestions’输入建议不提示的bug
      document.activeElement.blur();
      this.formInline.enterpriseCreditCode = "";
      this.formInline.enterpriseAddress = "";
      this.formInline.enterpriseRegistrationPlace = "";
    },
    // 点击头像 退出登录
    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      }
      if (command === "myWarranty") {
        this.myWarranty();
      }
    },
    // 我的
    myWarranty() {
      this.$router.push("/my");
    },
    // 退出登录
    logout() {
      window.sessionStorage.clear();
      this.$router.push("/");
    },
    // 取消
    handleClose() {
      this.$router.go(-1);
    },
    handleClick(row) {
      this.isVisible = true;
    },
    handleChange1(file, fileList) {
      this.fileList1 = fileList.slice(-3);
    },
    handleChange2(file, fileList) {
      this.fileList2 = fileList.slice(-3);
    },
    handleChange3(file, fileList) {
      this.fileList3 = fileList.slice(-3);
    },
    handleChange4(file, fileList) {
      this.fileList4 = fileList.slice(-3);
    },
    handleAffirm(row) {
      this.tableData;
    },
    handleRole() {
      this.isVisible = false;

      this.formInline.businessLicense = this.fileList1[0].response.fileName;
      this.formInline.financialStatements = this.fileList2[0].response.fileName;
      this.formInline.engineeringContract = this.fileList3[0].response.fileName;
      this.formInline.bidWinningNotice = this.fileList4[0].response.fileName;
      this.formInline.projectNo = this.row.id;
      this.formInline.insuranceNo = this.bankId || 1;
      this.formInline.id = window.sessionStorage.getItem("id");

      this.$refs.formInline.validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(
            "/Insurance/applicant/add1",
            this.formInline
          );
          if (res.code == 200) {
            this.$message.success("提交成功");
            this.$router.push("./my");
          }
        }
      });
    },
    handleSubmit() {
      if (!this.checked) {
        this.$message.error("请勾选");
        return;
      }

      if (this.fileList1.length == 0) {
        this.$message.error("请上传营业执照");
        return;
      }

      if (this.fileList2.length == 0) {
        this.$message.error("请上传财务报表");
        return;
      }

      if (this.fileList3.length == 0) {
        this.$message.error("请上传工程合同");
        return;
      }

      if (this.fileList4.length == 0) {
        this.$message.error("请上传中标通知书");
        return;
      }

      this.isVisible = true;
    },
    // 保险列表
    async getNewsList() {
      const params = {
        pageNum: 1,
        pageSize: 10,
      };
      const { data: res } = await this.$http.get(
        "Insurance/company/list1",
        params
      );
      if (res.code === 200) {
        this.newsList = res.rows;
      }
    },
    // 企业性质列表
    async getEnterpriseList() {
      const { data: res } = await this.$http.post(
        `system/dict/data/list1?dictType=enterprise_nature`
      );
      if (res.code === 200) {
        this.enterpriseList = res.rows;
      }
    },
    handleInsure(e) {
      window.open(e);
    },
    handleInsurance(e) {
      window.open(e);
    },
    handleTabs(item, index) {
      this.bankId = item.id;
      this.activeIndex = index;
    },
  },
};
</script>
<style lang="scss">
.home {
  width: 100%;
  height: 100%;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    height: 80px;
    margin: 0 auto 20px;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 50px;
        height: 40px;
        margin-right: 5px;
      }
      div {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
      }
    }
    .right {
      display: flex;
      align-items: center;
      cursor: pointer;
      .info {
        display: flex;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
        }
        .name {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .box-title {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 40px;
    margin: 0 auto 10px;
    .wire {
      width: 4px;
      height: 25px;
      background: #3f74dc;
    }
    .title {
      margin-left: 10px;
      font-size: 18px;
    }
  }
  // 银行
  .insurance {
    width: 1200px;
    height: 100%;
    margin: 0 auto 20px;

    .insurance-item:last-child {
      margin-bottom: 0px;
    }
    .insurance-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100px;
      background: #f7f7f7;
      border-radius: 10px;
      padding: 0 30px;
      box-sizing: border-box;
      margin-bottom: 20px;

      &.active {
        border: 1px solid #3f74dc;
      }

      .item-left {
        display: flex;
        align-items: center;
        img {
          width: 240px;
          height: 80px;
          margin-right: 20px;
        }
        div {
          font-size: 16px;
          font-weight: 600;
        }
      }
      .item-right {
        display: flex;
        color: #3f74dc;
        cursor: pointer;
        div {
          margin-left: 20px;
        }
      }
    }
  }
  // 投标
  .bid {
    width: 1200px;
    height: 100%;
    margin: 0 auto 20px;
    .bid-title {
      display: flex;
      align-items: center;
      width: 100%;
      height: 80px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }

      div {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .recognizee {
    width: 1200px;
    height: 100%;
    margin: 0 auto 20px;
    .recognizee-title {
      display: flex;
      align-items: center;
      width: 100%;
      height: 80px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }

      div {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .affirm {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 100%;
    margin: 0 auto 20px;
    font-size: 14px;
    color: #666;
    div {
      margin-left: 10px;
    }
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    height: 100px;
    margin: 0 auto 20px;
  }
}
</style>